import history from "router/history";

import { useLocation } from "react-router-dom";

const useHandleAuthError = () => {
  const location = useLocation();

  const onHandleError = (response) => {
    console.log("onHandleError", response);

    if (response) {
      const { status, data } = response;
      const { message } = data;
      if (status === 401 || status === 408) {
        console.log("its an auth error!");
        history.push(`/auth?referrer=${location.pathname}`);
      } else {
        console.log("error message: ", message);
      }
    } else {
      console.log("no response error =(");
    }
  };

  return [onHandleError];
};

export default useHandleAuthError;
